export default {"src":"/_next/static/media/16-icon.0e743240.svg","height":46,"width":43,"blurWidth":0,"blurHeight":0};